import { NgClass } from '@angular/common';
import { Component, EventEmitter, HostListener, inject, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HttpServiceService } from '../../services/http-service.service';

@Component({
  selector: 'app-nav-header',
  standalone: true,
  imports: [NgClass, RouterLink],
  templateUrl: './nav-header.component.html',
  styleUrl: './nav-header.component.css'
})
export class NavHeaderComponent {
  toggleVal: boolean = false; // Use boolean instead of any
  elementValue: string | null = null; // Use a more specific type
  sidebarStyle: string = '';
  localData: string | null = null; // Use a more specific type
  private httpService = inject(HttpServiceService);
  header_logo : string | null = '';

  @Output() sidebarToggle = new EventEmitter<{ toggleVal: boolean }>();
  @Output() emailOpne = new EventEmitter<{ emailval: boolean }>();
  

  ngOnInit() {
    this.localData = localStorage.getItem('data-sidebar-style');
    if (this.localData) {
      document.body.setAttribute('data-sidebar-style', this.localData);
    }
    // Partner-specific header logo (header_logo, already defaulted to the
    // login-page logo when unset), falling back to the bundled light-on-dark
    // wordmark (no tagline — it fits the 50px navy header strip).
    this.header_logo = this.httpService.getHeaderLogoUrl() || "/assets/images/servefar-logo-dark.svg";
  }

  toggleSidebar() {
    this.toggleVal = !this.toggleVal;
    this.sidebarToggle.emit({ toggleVal: this.toggleVal });
  }

  
}
